(function($) {

  var __ = {
      
    window: $(window),

    // Scene Controller
    controller: false,

    pageParallax : function(){
      __.controller = new ScrollMagic.Controller();

        console.log('setup scrollmagic scene');
      },

      setup: function() {
          __.pageParallax();
          __.addHandlers();
      },

    addHandlers: function() {
  //   var isMobile = ($(window).width() < 600);

  //   var slideAnimationForward = function() {
  //       $('.strategy-photo-container').animate({
  //         left: '-100%'
  //       }, 500, function() {
  //         $('.strategy-photo-container').css('left', '150%');
  //         // $('.strategy-photo-container').appendTo('.strategy-photo-container--outer');
  //       });
    
  //       $('.strategy-photo-container').animate({
  //           left: '0%'
  //       }, 500);
  
  //       setTimeout(function() {
  //         $('.strategy-photo-container').addClass('invisible').removeClass('visible');
  //         $($('.strategy-photo-container')[i]).removeClass('invisible').addClass('visible');
  //       }, 200);
  //   };
  
  //   var slideAnimationBackward= function() {
  //     $('.strategy-photo-container').animate({
  //       left: '100%'
  //     }, 500, function() {
  
  //       if ($('.strategy-photo-container').index() !== 0) {
  //         $('.strategy-photo-container').css('left', '-150%');
  //       } else {
  //         $('.strategy-photo-container').css('left', '-0%');
  //       }
    
  //       $('.strategy-photo-container').appendTo('.strategy-photo-container--outer');
  
  //     });
  
  //     $('.strategy-photo-container').next().animate({
  //         left: '0%'
  //     }, 500);
  
  //     setTimeout(function() {
  //       $('.strategy-photo-container').addClass('invisible').removeClass('visible');
  //       $($('.strategy-photo-container')[i]).removeClass('invisible').addClass('visible');
  //     }, 200);
  // };
  
  //   var preventScroll = function() {
  //     $('body').css('overflow', 'hidden');
  //   };
  
  //   var enableScroll = function() {
  //     $('body').css('overflow', 'scroll');
  //   };
  
  //   var transitionIcons = function(i) {
  //     $('.circle').removeClass('circle__white');
  //     $($('.circle')[i]).addClass('circle__white');
  //     $('.circle-text').removeClass('invisible').addClass('visible');
  //     $($('.circle-text')[i]).addClass('invisible').removeClass('visible');
  //     $('.box-20-inner').addClass('invisible').removeClass('visible');
  //     $($('.box-20-inner')[i]).removeClass('invisible').addClass('visible');
  //   };
  
  //   $('.go-to-contact').click(function() {
  //     $('html,body').animate({
  //         scrollTop: $(".social_campaign-contact-section").offset().top},
  //         'slow');
  //     enableScroll()
  //   });
  
  //   var transitionMobileIcons = function(i) {
  //     $('.circle-mobile').removeClass('circle__white');
  //     $($('.circle-mobile')[i]).addClass('circle__white');
  //   }
  
  //   var i = 0
  //   var scrollIsDisabled = false
  //   var ableToSlideAnimation = false
  //   var slideAnimStartTimerCreated = false
  //   var slideAnimEndTimerCreated = false
  //   var slideAnimationFinished = false
  
  //   if (!isMobile) {
  //     $(window).on('mousewheel', function(e) {

  //       if(slideAnimationFinished) return
        
  //       var elementOffset = ($('.social_campaign-strategy-section').offset().top);
  //       var elementAtTop = ($(window).scrollTop() > elementOffset);
  //       var onFirstItem = (i === 0);
  //       var onLastItem = (i === 3);
    
  //       var elem = document.querySelector('.social_campaign-strategy-section');
  //       var bounding = elem.getBoundingClientRect();
    
  //       if ((elementAtTop && (bounding.top <= 0) && (bounding.top > -70) && onFirstItem)) {
  //         preventScroll()
  //         scrollIsDisabled = true

  //         //to avoid create multiple timer
  //         if(!slideAnimStartTimerCreated) {
  //           slideAnimStartTimerCreated = true
  //           setTimeout(function() {
  //             ableToSlideAnimation = true
  //           }, 1000)
            
  //         }
          
  //       } else if (onLastItem) {

  //         if(!slideAnimEndTimerCreated) {
  //           slideAnimEndTimerCreated = true
  //           setTimeout(function(){
  //             enableScroll()
  //             scrollIsDisabled = false
  //             slideAnimationFinished = true
  //           }, 2000)
  //         }
          
  //         // if (bounding.top < -800 || bounding.top > 800) {
  //         //   i = 0
  //         //   // $($('.strategy-photo-container')[0]).css('left', '0')
  //         //   // $($('.strategy-photo-container')[0]).addClass('visible').removeClass('invisible')
  //         //   // $($('.strategy-photo-container')[3]).addClass('invisible').removeClass('visible')
  //         //   transitionIcons(i)
  //         //   ableToSlideAnimation = false
  //         // };
  //       };
    

  //       if(e.originalEvent.wheelDelta && scrollIsDisabled && ableToSlideAnimation) {
  //         ableToSlideAnimation = false
  //         i++
  //         setTimeout(function(){
  //           transitionIcons(i)
  //           slideAnimationForward()
  //         }, 50)
  //         setTimeout(function(){
  //           if(i < 3) {
  //             ableToSlideAnimation = true
  //           }
  //         }, 2000)
  //       }

  //     }) ;

  //     $('.box-36 .circle-3').on('click', function(){
  //       var currIndex = $('.box-36 .circle-3').index($(this));
  //       i = currIndex;
  //       transitionIcons(i);
  //       slideAnimationForward();
  //     })

  //   };
  
  
  
  //   previousI = 0
  //   nextI = 0
  
  //   if (isMobile) {
  //     $('.circle-container-mobile').on('click', function(e) {
  //       var tappedItemIndex = $('.circle-container-mobile').index(this)
  
  //       if (tappedItemIndex === 0) {
  //         $('.box-41').animate({'right': '-55vw'})
  //       } else if (tappedItemIndex === 1) {
  //         $('.box-41').animate({'right': '-27vw'})
  //       } else if (tappedItemIndex === 2) {
  //         $('.box-41').animate({'right': '0'})
  //       } else if (tappedItemIndex === 3) {
  //         $('.box-41').animate({'right': '30vw'})
  //       }
  
  //       i = tappedItemIndex
  //       nextI = i
  //       if (previousI < nextI) {
  //         slideAnimationForward()
  //         transitionMobileIcons(i)
  //       } else if (previousI > nextI) {
  //         i = tappedItemIndex
  //         slideAnimationBackward()
  //         transitionMobileIcons(i)
  //       };
  
  //       previousI = nextI
  
  //     });
  //   };


  }

};

window._animations.socialCampaign2 = __;
})(jQuery); // Fully reference jQuery after this point.